export const outbrainMixins: Record<string, Partial<OutbrainProps>> = {
  AR_35: {
    widgetId: 'AR_35',
  },
  AR_36: {
    widgetId: 'AR_36',
  },
  AR_37: {
    widgetId: 'AR_37',
  },
  AR_45: {
    widgetId: 'AR_45',
  },
  AR_38: {
    widgetId: 'AR_38',
  },
  AR_44: {
    widgetId: 'AR_44',
  },
  AR_27: {
    widgetId: 'AR_27',
  },
  SB_2: {
    //siderail
    widgetId: 'SB_2',
  },
  AR_31: {
    //below thumbnails
    widgetId: 'AR_31',
  },
}

export const placementsToOutbrainWidgets: Record<string, string> = {
  // Homepage placements
  on_newtab_r1_c2: 'AR_35',
  on_newtab_r1_topright: 'AR_36',
  on_newtab_r2_c1: 'AR_37',
  on_newtab_r3_right: 'AR_45',
  on_newtab_r4_c1: 'AR_44',
  on_newtab_endless_native: 'AR_38',
  on_newtab_endless_right: 'AR_38',
  on_newtab_slider_1: 'AR_27',
  on_newtab_slider_2: 'AR_27',
  // Article page placements
  on_article_siderail: 'SB_2',
}
